export default __webpack_public_path__ + "static/media/tdh-primary-360.710876bc.png";